var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header',{staticClass:"pb-5",attrs:{"sidebar":_vm.sidebar}}),(!_vm.errorPage)?_c('ShopIndividual'):_vm._e(),(_vm.errorPage)?_c('errorPage'):_vm._e(),_c('Footer',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }